import type { authClient } from '@/lib/auth-client';

type SessionData = NonNullable<ReturnType<typeof authClient.useSession>['data']>;
type SessionUserWithRegions = SessionData['user'] & {
  regions?: Array<{ id: string; name: string }>;
};

export function getDefaultAuthenticatedPath(session: SessionData) {
  const user = session.user as SessionUserWithRegions;
  const userRegions = user.regions ?? [];

  if (userRegions.length === 1) {
    return `/admin/regions/${userRegions[0].id}/salons`;
  }

  return '/admin/regions';
}
